import React, { Component } from 'react';
import { ColorPicker } from '../../components';
import PreferenceRequiredInteraction from "../../components/preference-required-interaction/preference-required-interaction";
import './element-charts-infographics-properties.css';

export default class ElementChartsInfographicsProperties extends Component {
  constructor(props) {
    super(props);

    this.state = {
      content: this.props.content,
      activeTab: 'content'
    };
  }

  onContentTitleChange = (e) => {
    const content = { ...this.state.content };
    content.content_title = e.currentTarget.value !== "" ? e.currentTarget.value : content.content_title;
    
    this.setState({ content }, () => {
      this.props.onContentChange(content);
    });
  };

  onContentTypeChange = (e) => {
    const content = { ...this.state.content };
    content.content_type = e.target.value;
    
    this.setState({ content }, () => {
      this.props.onContentChange(content);
    });
  };

  onChartTypeChange = (e) => {
    const content = { ...this.state.content };
    content.chart_type = e.target.value;
    
    this.setState({ content }, () => {
      this.props.onContentChange(content);
    });
  };

  onChartHeightChange = (e) => {
    const content = { ...this.state.content };
    content.chart_height = parseInt(e.currentTarget.value) || 400;
    
    this.setState({ content }, () => {
      this.props.onContentChange(content);
    });
  };

  onBackgroundColorChange = (color) => {
    const content = { ...this.state.content };
    content.background_color = color;
    
    this.setState({ content }, () => {
      this.props.onContentChange(content);
    });
  };

  onPaddingTopChange = (e) => {
    const content = { ...this.state.content };
    content.padding_top = e.currentTarget.value !== "" ? parseInt(e.currentTarget.value) : content.padding_top;
    
    this.setState({ content }, () => {
      this.props.onContentChange(content);
    });
  };

  onPaddingBottomChange = (e) => {
    const content = { ...this.state.content };
    content.padding_bottom = e.currentTarget.value !== "" ? parseInt(e.currentTarget.value) : content.padding_bottom;
    
    this.setState({ content }, () => {
      this.props.onContentChange(content);
    });
  };

  onDescriptionChange = (e) => {
    const content = { ...this.state.content };
    content.description = e.currentTarget.value;
    
    this.setState({ content }, () => {
      this.props.onContentChange(content);
    });
  };

  onAccessibilityDescriptionChange = (e) => {
    const content = { ...this.state.content };
    content.accessibility_description = e.currentTarget.value;
    
    this.setState({ content }, () => {
      this.props.onContentChange(content);
    });
  };

  onShowFallbackTableChange = (e) => {
    const content = { ...this.state.content };
    content.show_fallback_table = e.target.checked;
    
    this.setState({ content }, () => {
      this.props.onContentChange(content);
    });
  };



  getRandomColor = (index, alpha = 0.6) => {
    const colors = [
      `rgba(45, 123, 69, ${alpha})`,
      `rgba(255, 99, 132, ${alpha})`,
      `rgba(54, 162, 235, ${alpha})`,
      `rgba(255, 205, 86, ${alpha})`,
      `rgba(75, 192, 192, ${alpha})`,
      `rgba(153, 102, 255, ${alpha})`,
      `rgba(255, 159, 64, ${alpha})`
    ];
    return colors[index % colors.length];
  };

  addDataset = () => {
    const content = { ...this.state.content };
    if (!content.chart_data) content.chart_data = { labels: [], datasets: [] };
    
    const newDataset = {
      label: `Série ${content.chart_data.datasets.length + 1}`,
      data: new Array(content.chart_data.labels.length).fill(0),
      backgroundColor: this.getRandomColor(content.chart_data.datasets.length),
      borderColor: this.getRandomColor(content.chart_data.datasets.length, 0.8),
      borderWidth: 2
    };
    
    content.chart_data.datasets.push(newDataset);
    
    this.setState({ content }, () => {
      this.props.onContentChange(content);
    });
  };

  removeDataset = (index) => {
    const content = { ...this.state.content };
    if (content.chart_data && content.chart_data.datasets) {
      content.chart_data.datasets.splice(index, 1);
      
      this.setState({ content }, () => {
        this.props.onContentChange(content);
      });
    }
  };

  updateDatasetLabel = (index, label) => {
    const content = { ...this.state.content };
    if (content.chart_data && content.chart_data.datasets[index]) {
      content.chart_data.datasets[index].label = label;
      
      this.setState({ content }, () => {
        this.props.onContentChange(content);
      });
    }
  };



  onChartTitleChange = (e) => {
    const content = { ...this.state.content };
    if (!content.chart_options) content.chart_options = {};
    content.chart_options.chart_title = e.target.value;
    
    this.setState({ content }, () => {
      this.props.onContentChange(content);
    });
  };

  onXAxisLabelChange = (e) => {
    const content = { ...this.state.content };
    if (!content.chart_options) content.chart_options = {};
    content.chart_options.x_axis_label = e.target.value;
    
    this.setState({ content }, () => {
      this.props.onContentChange(content);
    });
  };

  onYAxisLabelChange = (e) => {
    const content = { ...this.state.content };
    if (!content.chart_options) content.chart_options = {};
    content.chart_options.y_axis_label = e.target.value;
    
    this.setState({ content }, () => {
      this.props.onContentChange(content);
    });
  };

  onShowLegendChange = (e) => {
    const content = { ...this.state.content };
    if (!content.chart_options) content.chart_options = {};
    content.chart_options.show_legend = e.target.checked;
    
    this.setState({ content }, () => {
      this.props.onContentChange(content);
    });
  };

  onLegendPositionChange = (e) => {
    const content = { ...this.state.content };
    if (!content.chart_options) content.chart_options = {};
    content.chart_options.legend_position = e.target.value;
    
    this.setState({ content }, () => {
      this.props.onContentChange(content);
    });
  };

  onShowTooltipsChange = (e) => {
    const content = { ...this.state.content };
    if (!content.chart_options) content.chart_options = {};
    content.chart_options.show_tooltips = e.target.checked;
    
    this.setState({ content }, () => {
      this.props.onContentChange(content);
    });
  };

  updateChartLabel = (index, label) => {
    const content = { ...this.state.content };
    if (!content.chart_data) content.chart_data = { labels: [], datasets: [] };
    if (!content.chart_data.labels[index]) content.chart_data.labels[index] = '';
    
    content.chart_data.labels[index] = label;
    
    this.setState({ content }, () => {
      this.props.onContentChange(content);
    });
  };

  updateLabelColor = (index, color) => {
    const content = { ...this.state.content };
    if (!content.chart_data) content.chart_data = { labels: [], datasets: [] };
    if (!content.label_colors) content.label_colors = [];
    
    content.label_colors[index] = color;
    content._chartKey = Date.now();
    
    this.setState({ content }, () => {
      this.props.onContentChange(content);
    });
  };

  updateDatasetColor = (index, color) => {
    const content = { ...this.state.content };
    if (content.chart_data && content.chart_data.datasets[index]) {
      content.chart_data.datasets[index].backgroundColor = color;
      content.chart_data.datasets[index].borderColor = color;
      content._chartKey = Date.now();
      
      this.setState({ content }, () => {
        this.props.onContentChange(content);
      });
    }
  };

  updateDatasetValue = (datasetIndex, valueIndex, value) => {
    const content = { ...this.state.content };
    if (content.chart_data && content.chart_data.datasets[datasetIndex]) {
      if (!content.chart_data.datasets[datasetIndex].data[valueIndex]) {
        content.chart_data.datasets[datasetIndex].data[valueIndex] = 0;
      }
      content.chart_data.datasets[datasetIndex].data[valueIndex] = parseFloat(value) || 0;
      
      this.setState({ content }, () => {
        this.props.onContentChange(content);
      });
    }
  };

  addLabel = () => {
    const content = { ...this.state.content };
    if (!content.chart_data) content.chart_data = { labels: [], datasets: [] };
    if (!content.label_colors) content.label_colors = [];
    
    content.chart_data.labels.push(`Label ${content.chart_data.labels.length + 1}`);
    content.label_colors.push(this.getRandomColor(content.chart_data.labels.length - 1));
    
    // Adicionar valor 0 para cada dataset
    content.chart_data.datasets.forEach(dataset => {
      dataset.data.push(0);
    });
    
    this.setState({ content }, () => {
      this.props.onContentChange(content);
    });
  };

  removeLabel = (index) => {
    const content = { ...this.state.content };
    if (content.chart_data && content.chart_data.labels) {
      content.chart_data.labels.splice(index, 1);
      
      if (content.label_colors) {
        content.label_colors.splice(index, 1);
      }
      
      // Remover valor correspondente de cada dataset
      content.chart_data.datasets.forEach(dataset => {
        if (dataset.data[index] !== undefined) {
          dataset.data.splice(index, 1);
        }
      });
      
      this.setState({ content }, () => {
        this.props.onContentChange(content);
      });
    }
  };

  render() {
    const { content, activeTab } = this.state;
    const { labels } = this.props;

    return (
      <div className="rdp-element-charts-infographics-properties">
        <ul className="rdp-composer-element-edit-tabs">
          <li 
            className={`rdp-composer-element-edit-tabs-item ${activeTab === 'content' ? 'active' : ''}`}
            onClick={() => this.setState({ activeTab: 'content' })}
          >
            Conteúdo
          </li>
          <li 
            className={`rdp-composer-element-edit-tabs-item ${activeTab === 'settings' ? 'active' : ''}`}
            onClick={() => this.setState({ activeTab: 'settings' })}
          >
            Configurações
          </li>
          <li 
            className={`rdp-composer-element-edit-tabs-item ${activeTab === 'data' ? 'active' : ''}`}
            onClick={() => this.setState({ activeTab: 'data' })}
          >
            Dados
          </li>
        </ul>
        
        <div className="rdp-composer-element-edit-body">
          {activeTab === 'content' && (
            <>
              <span className="rdp-composer-element-edit-label">Título do Conteúdo:</span>
              <input 
                type="text" 
                className="rdp-composer-element-edit-input" 
                onChange={this.onContentTitleChange} 
                defaultValue={content.content_title}
              />

              <span className="rdp-composer-element-edit-label">Tipo de Gráfico:</span>
              <select 
                defaultValue={content.chart_type || 'bar'} 
                className="rdp-composer-element-edit-select" 
                onChange={this.onChartTypeChange}
              >
                <option value="bar">Barras</option>
                <option value="line">Linhas</option>
                <option value="pie">Pizza</option>
                <option value="doughnut">Rosca</option>
              </select>

              <span className="rdp-composer-element-edit-label">Descrição:</span>
              <textarea 
                className="rdp-composer-element-edit-textarea"
                onChange={this.onDescriptionChange} 
                value={content.description || ''}
                placeholder="Descrição do gráfico"
                rows="3"
              />

              <span className="rdp-composer-element-edit-label">Descrição para Acessibilidade:</span>
              <textarea 
                className="rdp-composer-element-edit-textarea"
                onChange={this.onAccessibilityDescriptionChange} 
                value={content.accessibility_description || ''}
                placeholder="Descrição detalhada para leitores de tela"
                rows="2"
              />

              <label className="rdp-composer-element-edit-checkbox-label">
                <input 
                  type="checkbox" 
                  checked={content.show_fallback_table || false}
                  onChange={this.onShowFallbackTableChange}
                />
                Mostrar tabela de dados como fallback
              </label>
            </>
          )}

          {activeTab === 'settings' && (
            <>
              <span className="rdp-composer-element-edit-label">Altura do Gráfico:</span>
              <input 
                type="number" 
                className="rdp-composer-element-edit-input px" 
                onChange={this.onChartHeightChange} 
                defaultValue={content.chart_height || 400}
                min="200"
                max="800"
              />

              <span className="rdp-composer-element-edit-label">Cor de Fundo:</span>
              <ColorPicker 
                labels={this.props.labels} 
                color={content.background_color || '#FFFFFF'} 
                onChange={this.onBackgroundColorChange} 
              />

              <h4>Formatação do Gráfico</h4>
                  
                  <span className="rdp-composer-element-edit-label">Título do Gráfico:</span>
                  <input 
                    type="text" 
                    className="rdp-composer-element-edit-input" 
                    onChange={this.onChartTitleChange} 
                    defaultValue={(content.chart_options && content.chart_options.chart_title) || ''}
                    placeholder="Título do gráfico"
                  />

                  {(content.chart_type === 'bar' || content.chart_type === 'line') && (
                    <>
                      <span className="rdp-composer-element-edit-label">Rótulo do Eixo X:</span>
                      <input 
                        type="text" 
                        className="rdp-composer-element-edit-input" 
                        onChange={this.onXAxisLabelChange} 
                        defaultValue={(content.chart_options && content.chart_options.x_axis_label) || ''}
                        placeholder="Rótulo do eixo horizontal"
                      />

                      <span className="rdp-composer-element-edit-label">Rótulo do Eixo Y:</span>
                      <input 
                        type="text" 
                        className="rdp-composer-element-edit-input" 
                        onChange={this.onYAxisLabelChange} 
                        defaultValue={(content.chart_options && content.chart_options.y_axis_label) || ''}
                        placeholder="Rótulo do eixo vertical"
                      />
                    </>
                  )}

                  <label className="rdp-composer-element-edit-checkbox-label">
                    <input 
                      type="checkbox" 
                      checked={(content.chart_options && content.chart_options.show_legend) !== false}
                      onChange={this.onShowLegendChange}
                    />
                    Mostrar legenda
                  </label>

                  <span className="rdp-composer-element-edit-label">Posição da Legenda:</span>
                  <select 
                    defaultValue={(content.chart_options && content.chart_options.legend_position) || 'top'} 
                    className="rdp-composer-element-edit-select" 
                    onChange={this.onLegendPositionChange}
                  >
                    <option value="top">Superior</option>
                    <option value="bottom">Inferior</option>
                    <option value="left">Esquerda</option>
                    <option value="right">Direita</option>
                  </select>

              <label className="rdp-composer-element-edit-checkbox-label">
                <input 
                  type="checkbox" 
                  checked={(content.chart_options && content.chart_options.show_tooltips) !== false}
                  onChange={this.onShowTooltipsChange}
                />
                Mostrar tooltips
              </label>

              <span className="rdp-composer-element-edit-label">Margem Superior:</span>
              <input 
                type="number" 
                className="rdp-composer-element-edit-input px" 
                onChange={this.onPaddingTopChange} 
                defaultValue={content.padding_top || 35}
              />

              <span className="rdp-composer-element-edit-label">Margem Inferior:</span>
              <input 
                type="number" 
                className="rdp-composer-element-edit-input px" 
                onChange={this.onPaddingBottomChange} 
                defaultValue={content.padding_bottom || 35}
              />

              <PreferenceRequiredInteraction 
                labels={labels} 
                content={content} 
                onContentChange={(content) => this.setState({ content }, () => this.props.onContentChange(content))}
              />
            </>
          )}

          {activeTab === 'data' && (
            <>


              <div className="rdp-charts-data-manual">
                <h4>Edição Manual</h4>
                
                <div className="rdp-charts-labels">
                  <div className="rdp-charts-datasets-header">
                    <span>Categorias/Labels</span>
                    <button 
                      className="rdp-composer-element-edit-button-small"
                      onClick={this.addLabel}
                    >
                      Adicionar Label
                    </button>
                  </div>
                  
                  {content.chart_data && content.chart_data.labels && content.chart_data.labels.map((label, index) => (
                    <div key={index} className="rdp-charts-dataset-item">
                      <input 
                        type="text"
                        className="rdp-composer-element-edit-input"
                        value={label || ''}
                        onChange={(e) => this.updateChartLabel(index, e.target.value)}
                        placeholder={`Label ${index + 1}`}
                      />
                      {(content.chart_type === 'pie' || content.chart_type === 'doughnut') && (
                        <ColorPicker 
                          labels={this.props.labels} 
                          color={(content.label_colors && content.label_colors[index]) || this.getRandomColor(index)} 
                          onChange={(color) => this.updateLabelColor(index, color)} 
                        />
                      )}
                      <button 
                        className="rdp-composer-element-edit-button-remove"
                        onClick={() => this.removeLabel(index)}
                        title="Remover"
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>

                <div className="rdp-charts-datasets">
                  <div className="rdp-charts-datasets-header">
                    <span>Séries de Dados</span>
                    <button 
                      className="rdp-composer-element-edit-button-small"
                      onClick={this.addDataset}
                    >
                      Adicionar Série
                    </button>
                  </div>
                  
                  {content.chart_data && content.chart_data.datasets && content.chart_data.datasets.map((dataset, datasetIndex) => (
                    <div key={datasetIndex} className="rdp-charts-dataset-item">
                      <div className="rdp-charts-dataset-header">
                        <input 
                          type="text"
                          className="rdp-composer-element-edit-input"
                          value={dataset.label || ''}
                          onChange={(e) => this.updateDatasetLabel(datasetIndex, e.target.value)}
                          placeholder={`Série ${datasetIndex + 1}`}
                        />
                        {(content.chart_type === 'bar' || content.chart_type === 'line') && (
                          <ColorPicker 
                            labels={this.props.labels} 
                            color={dataset.backgroundColor || this.getRandomColor(datasetIndex)} 
                            onChange={(color) => this.updateDatasetColor(datasetIndex, color)} 
                          />
                        )}
                        <button 
                          className="rdp-composer-element-edit-button-remove"
                          onClick={() => this.removeDataset(datasetIndex)}
                          title="Remover"
                        >
                          ×
                        </button>
                      </div>
                      
                      <div className="rdp-charts-dataset-values">
                        <span className="rdp-composer-element-edit-label">Valores:</span>
                        <div className="rdp-charts-values-grid">
                          {content.chart_data.labels && content.chart_data.labels.map((label, valueIndex) => (
                            <div key={valueIndex} className="rdp-charts-value-item">
                              <span className="rdp-charts-value-label">{label}:</span>
                              <input 
                                type="number"
                                className="rdp-composer-element-edit-input"
                                value={dataset.data[valueIndex] || 0}
                                onChange={(e) => this.updateDatasetValue(datasetIndex, valueIndex, e.target.value)}
                                placeholder="0"
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}
        </div>

      </div>
    );
  }


}